import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig, C4Option } from '../c4-input';
import { C4Form } from '../c4-form';

declare var module: any;

@Component({
  selector: 'c4-input-float',
  templateUrl: 'c4-input-float.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputFloat extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: number;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() precision: number;
  @Input() increment: number;
  @Input() stepCount: number;
  @Input() min: number;
  @Input() max: number;
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() readonly: boolean;

  sensibleDefaults = {
    precision: 1,
    increment: 0.1
  }

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }

  ngOnInit() {
    super.ngOnInit();
    this.increment = (this.precision !== undefined) ? 1 / Math.pow(10, this.precision) : this.increment;
  }

  init(model: C4Option, config: C4InputConfig) {
    super.init(model, config);

    this.precision = this.sensibleDefaults.precision;
    this.increment = this.sensibleDefaults.increment;
    this.min = model.low;
    this.max = model.high;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/float/c4-input-float.ts